<template>
    <div class="feedback-step question--no-tags">
        <!-- <div class="heading-third--grey">{{ feedbackData.text }}</div> -->
        <div class="heading-third--grey ">{{ feedbackData.text }}</div>
        <div class="rating-tags">
            <div v-for="(tag, index) in feedbackData.options['tags']" 
                :key="index" 
                class="tag-bubble"
                :class="[{'selected': selectedTags.includes(tag)}]"
                @click="selectTag(tag)">
                <!-- <span>{{ tag }}</span> -->
                <span>{{ tag }}</span>
            </div>
        </div>
        <QuestionError :showEmptyError="showEmptyError" />
    </div>
</template>

<script>
    import QuestionError from '@/components/QuestionError.vue'

    export default {
        name: "StepNoOrTags",
        props: {
            feedbackData: {
                required: true,
                type: Object,
            },
            savedAnswer: {
                required: true,
            },
            surveyPassingId: {},
            showEmptyError: {
                type: Boolean,
                default: false
            }
        },
        components: {QuestionError},
        data() {
            return {
                yesNo: '',
                selectedTags: [],
            }
        }, 
        methods: {
            selectTag(tag) {
                if (this.yesNo !== 1)
                    this.yesNo = 1
                if (!this.selectedTags.includes(tag)) {
                    this.selectedTags.push(tag);
                } else {
                    let index = this.selectedTags.indexOf(tag);
                    if (index > -1) {
                        this.selectedTags.splice(index, 1);
                    }
                }
                this.$emit('hideError')
            }
        }, 
        mounted() {
            if (this.savedAnswer) {
                this.yesNo = this.savedAnswer.value;
                this.selectedTags = this.savedAnswer.tags;
            }
            this.$emit('showFeedback', true);
        },
        computed: {
            stepResult() {
                let stepResult = {
                    answer_data: JSON.stringify({
                        value: this.yesNo,
                        tags: this.selectedTags,
                    }),
                    question_id: this.feedbackData.id,
                };
                if (this.surveyPassingId) {
                    this._lodash.assign(stepResult, {survey_passing_id: this.surveyPassingId});
                }
                return stepResult
            },
            canContinue() {
                return 1 ;
            },
            feedbackDataId() {
                return this.feedbackData && this.feedbackData.id;
            },
        },
        watch: {
            savedAnswer() {
                if (this.savedAnswer) {
                    this.yesNo = this.savedAnswer.value;
                }
                else {
                    this.yesNo = ''
                }
            },
            selectedTags() {
                if (this.selectedTags.length < 1)
                    this.$emit('updateProgress', false);
                else 
                    this.$emit('updateProgress', true);
            },
            feedbackDataId() {
                if (!this.savedAnswer) {
                    this.yesNo = '';
                }
            }
        },
    }
</script>

<style scoped>

</style>
